export default "__VITE_ASSET__BBjB4YRn__"